/**
 * @typedef {Object<string, Object<string, Array<VisitorDocumentListItem>>>} VisitorDocumentList
 * VisitorDocumentList example:
 * {
 *   "data": {
 *     "5": {
 *       "doc_type_1": [
 *         {
 *           "meta": {
 *             "checked": 0,
 *             "date_of_expire": "2100-01-01",
 *             "uuid": "00000000-0000-0000-0000-000000000000.jpeg"
 *           },
 *           "mimeType": "image/jpeg",
 *           "src": "/ru/demo/get-file/visitor-document?personalDocId=6",
 *           "thumb": "/ru/demo/get-file/visitor-document?personalDocId=6",
 *           "title": "Тип документа 1"
 *         },
 *         {
 *           "meta": {
 *             "checked": 1,
 *             "date_of_expire": "2100-01-01",
 *             "uuid": "00000000-0000-0000-0000-000000000001.pdf"
 *           },
 *           "mimeType": "application/pdf",
 *           "src": "/ru/demo/get-file/visitor-document?personalDocId=7",
 *           "thumb": "/ru/demo/img/pdf_splash.svg",
 *           "title": "Тип документа 1"
 *         }
 *       ],
 *       "doc_type_2": [
 *         {
 *           "meta": {
 *             "checked": 1,
 *             "date_of_expire": "2100-01-01",
 *             "uuid": "00000000-0000-0000-0000-000000000003.pdf"
 *           },
 *           "mimeType": "application/pdf",
 *           "src": "/ru/demo/get-file/visitor-document?personalDocId=8",
 *           "thumb": "/ru/demo/img/pdf_splash.svg",
 *           "title": "Тип документа 2"
 *         }
 *       ]
 *     },
 *     "6": {
 *       "doc_type_1": [
 *         {
 *           "meta": {
 *             "checked": 1,
 *             "date_of_expire": "2100-01-01",
 *             "uuid": "00000000-0000-0000-0000-000000000003.pdf"
 *           },
 *           "mimeType": "application/pdf",
 *           "src": "/ru/demo/get-file/visitor-document?personalDocId=9",
 *           "thumb": "/ru/demo/img/pdf_splash.svg",
 *           "title": "Тип документа 2"
 *         }
 *       ]
 *     }
 *   }
 * }
 */

import KeyItemPairDto from '@/common/classes/VisitorDocumentList/KeyItemPairDto'

/**
 * @member {Promise<Array<KeyItemPairDto>>|Array<KeyItemPairDto>} keyItemPairs
 * @member {Promise<Array<KeyItemPairDto>>|Array<KeyItemPairDto>} out
 */
export default class EagerPreviewVisitorDocumentListHydrator {
  keyItemPairs = []
  out = []

  /**
   * @param {Promise<Array<KeyItemPairDto>>|Array<KeyItemPairDto>} keyItemPairs
   * @return EagerPreviewVisitorDocumentListHydrator
   */
  setKeyItemPairs(keyItemPairs) {
    this.keyItemPairs = keyItemPairs

    return this
  }

  /**
   * @param {Promise<Array<KeyItemPairDto>>|Array<KeyItemPairDto>} out
   * @return EagerPreviewVisitorDocumentListHydrator
   */
  setOut(out) {
    this.out = out

    return this
  }

  /**
   * @return {Promise<VisitorDocumentList>}
   */
  async hydrate() {
    let keyItemPairs = await this.keyItemPairs

    if (!keyItemPairs) {
      throw new Error('No keyItemPairs set')
    }

    const out = await this.out

    if (!out) {
      throw new Error('No out object set')
    }

    const thumbnailPromises = []
    for (const keyItemPair of keyItemPairs) {
      let promise = new Promise(resolve => resolve(new KeyItemPairDto(keyItemPair)))
      if (keyItemPair.item.thumb) {
        promise = fetch(keyItemPair.item.thumb)
          .then(response => response
            .blob()
            .then(function(blob) {
              const key = keyItemPair.key
              const item = Object.assign({}, keyItemPair.item, {
                thumb: URL.createObjectURL(blob)
              })

              return new KeyItemPairDto({ key, item })
            })
          )
          .catch(() => new KeyItemPairDto(keyItemPair))
      }
      thumbnailPromises.push(promise)
    }

    keyItemPairs = await Promise.all(thumbnailPromises)
    while (out.length > 0) {
      out.pop()
    }
    for (const keyItemPair of keyItemPairs) {
      out.push(keyItemPair)
    }

    return out
  }
}
